import { color } from "three/examples/jsm/nodes/Nodes"
import "./Loading.css"

export default function Loading() {

    return (

        // <h1 id="Loading">
        //     <span className="let1">l</span>
        //     <span className="let2">o</span>
        //     <span className="let3">a</span>
        //     <span className="let4">d</span>
        //     <span className="let5">i</span>
        //     <span className="let6">n</span>
        //     <span className="let7">g</span>
        // </h1>

        <div className="loading-container" id="Loading">
            <img src="img/logo.jpg" alt="Loading" className="loading-image" />
            <img src="img/g.gif" alt="Loading..." className="loading-gif" />
            <p className="textloading">لطفا منتظر بمانید</p>
        </div>
    )
}